import LzMCrud from '@lz/models/crud/Crud';

const config = new LzMCrud({
  ident: 'media',
  baseRoute: '/system/media',
});

export default config;
